var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.446,
    height: 17.522,
    viewBox: "0 0 18.446 17.522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-star_-_Outline",
    "data-name": "Icon material-star - Outline",
    d: "M16.7,19.24,11,15.8,5.3,19.24l1.513-6.484L1.777,8.394l6.632-.563L11,1.719l2.591,6.113,6.632.563-5.036,4.362ZM11,14.632l4.188,2.528L14.077,12.4l3.7-3.206-4.872-.413L11,4.281l-1.905,4.5L4.223,9.19l3.7,3.206L6.812,17.16Z",
    transform: "translate(-1.777 -1.719)",
    fill: "#7a7a7a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutline);
export default __webpack_public_path__ + "static/media/StarOutline.a6205430.svg";
export { ForwardRef as ReactComponent };